import { c as _c } from "react/compiler-runtime";
import type { GetHistoryEntry } from '@repo/schema/history';
import { Link } from '../../adapters/next.tsx';

// The Original Load that a Duplicate's `duplicated` entry points back to, if it names one.
const getOriginalLoadId = ({
  event,
  subject
}: GetHistoryEntry) => event === 'duplicated' && subject?.type === 'Load' ? subject.id : null;

/** An entry's description, or `fallback`; a Duplicate's `duplicated` entry links its Original Load. */
export const HistoryDescription = t0 => {
  const $ = _c(5);
  const {
    entry,
    fallback
  } = t0;
  let t1;
  if ($[0] !== entry) {
    t1 = getOriginalLoadId(entry);
    $[0] = entry;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const originalLoadId = t1;
  if (originalLoadId === null) {
    return entry.description || fallback;
  }
  const t2 = `/loads/${originalLoadId}/overview`;
  let t3;
  if ($[2] !== originalLoadId || $[3] !== t2) {
    t3 = <>Duplicated from load{" "}<Link className="underline underline-offset-2" href={t2} data-sentry-element="Link" data-sentry-source-file="history-description.tsx">#{originalLoadId}</Link></>;
    $[2] = originalLoadId;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};